import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getModosEmpleo, getUsosOrigen } from "../../../../../../../../../redux/actions/resolucion";
import { isNoMeasureUso } from "../../../../../../../../../util/resolucion";
import { normalizeString } from "../../../../../../../../../util/stringUtils";
import FormikActions from "../../../../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../../../../commons/formik/FormikAutocomplete";
import { StyledResolucion } from "../../../../../../../../styled/Prevencion";
import { ValidateUsos } from "../../../formValidations";


const UsosForm = ({ values, open, handleClose, handleSubmit, id }) => {
    const dispatch = useDispatch();

    const usos = useSelector((state) => state.resolucion.usosOrigen.data);
    const modosEmpleo = useSelector((state) => state.resolucion.modosEmpleo.data);

    return (
        <Dialog open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Uso</DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={ValidateUsos}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <DialogContent>
                            <Grid container >
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikAutocomplete
                                        name="usos"
                                        label="Origen/Uso *"
                                        fullWidth
                                        options={usos}
                                        renderOption={(option) => option.nombre}
                                        filterOptions={(option) => option.nombre}
                                        getOptions={() => (dispatch(getUsosOrigen()))}
                                        callBack={(value) => {
                                            if (value) {
                                                let nombre = normalizeString(value.nombre)
                                                setFieldValue("nombreUso", nombre)
                                                if (nombre === normalizeString("Ambiental")) {
                                                    setFieldValue("modoEmpleo", null)
                                                }
                                                if (isNoMeasureUso(nombre)) {
                                                    setFieldValue("unidad", "");
                                                    setFieldValue("cantidad", "");
                                                    setFieldValue("sinMedicion", true)

                                                } else {
                                                    setFieldValue("sinMedicion", false)
                                                }
                                            } else {
                                                setFieldValue("modoEmpleo", null);
                                                setFieldValue("unidad", "");
                                                setFieldValue("cantidad", "");
                                                setFieldValue("sinMedicion", false)
                                            }
                                        }}
                                    />
                                </StyledResolucion.DialogGridItem>
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikAutocomplete
                                        name="modoEmpleo"
                                        label={`Modo de Empleo ${normalizeString(values.nombreUso) === normalizeString("Ambiental") ? "" : "*"}`}
                                        fullWidth
                                        options={modosEmpleo}
                                        renderOption={(option) => option.nombre}
                                        filterOptions={(option) => option.nombre}
                                        disabled={!values.usos || normalizeString(values.nombreUso) === normalizeString("Ambiental")}
                                        getOptions={() => (dispatch(getModosEmpleo()))}

                                    />
                                </StyledResolucion.DialogGridItem>


                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}

export default UsosForm;